import { HTMLProps } from "react";
import { useAppStore } from "@/store/app";
import { cn, getLocationStateName } from "@/utils/helpers";
import { getLang } from "@/utils/selectors";
import Tooltip from "@/components/explorer/Tooltip";
import styles from "../Map.module.css";

export interface MapTooltipProps extends HTMLProps<HTMLElement> {}

export default function MapTooltip({
	className
} : MapTooltipProps) {
	const controls = useAppStore(store => store.controls);
	const hoveredLocation = useAppStore(store => store.hoveredLocation);
	const hoveredPoint = useAppStore(store => store.hoveredPoint);

	return (
		<Tooltip
			x={hoveredPoint?.x}
			y={hoveredPoint?.y}
			show={Boolean(hoveredLocation)}
			view={controls.view}
			stat={controls.stat}
			value={hoveredLocation?.value}
			title={hoveredLocation?.name}
			subtitle={hoveredLocation?.id
				? getLocationStateName(hoveredLocation.id)
				: null
			}
			footer={getLang("map", "tooltip", "footer")}
			className={cn(
				className,
				styles.MapTooltip
			)}
		/>
	)
}